import { render, staticRenderFns } from "./custom-object-edit.vue?vue&type=template&id=e20dd226&scoped=true&"
import script from "./custom-object-edit.js?vue&type=script&lang=js&"
export * from "./custom-object-edit.js?vue&type=script&lang=js&"
import style0 from "./custom-object-edit.scss?vue&type=style&index=0&id=e20dd226&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e20dd226",
  null
  
)

component.options.__file = "custom-object-edit.vue"
export default component.exports